module.exports = __webpack_public_path__ + "static/media/4-iveco.7c981995.jpg";